import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let task_id = useDataValue({
    context: 'card',
    path: 'id',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_done',
      task_id,
    })
  }
}
